export type ThemeMode = 'light' | 'dark' | 'system';

export interface ColorPalette {
  id: string;
  name: string;
  primary: string;
  secondary: string;
  tertiary: string;
}

export const COLOR_PALETTES: ColorPalette[] = [
  {
    id: 'ocean',
    name: 'Ocean',
    primary: '#005cba',
    secondary: '#008391',
    tertiary: '#00bccf',
  },
  {
    id: 'classic',
    name: 'Classic',
    primary: '#6750A4',
    secondary: '#B4004E',
    tertiary: '#8B5000',
  },
  {
    id: 'nature',
    name: 'Nature',
    primary: '#346B1F',
    secondary: '#006874',
    tertiary: '#00687B',
  },
  {
    id: 'sunset',
    name: 'Sunset',
    primary: '#C2185B',
    secondary: '#FF5722',
    tertiary: '#FF9800',
  },
  {
    id: 'midnight',
    name: 'Midnight',
    primary: '#3949AB',
    secondary: '#303F9F',
    tertiary: '#1976D2',
  },
  {
    id: 'forest',
    name: 'Forest',
    primary: '#2E7D32',
    secondary: '#1B5E20',
    tertiary: '#388E3C',
  },
  {
    id: 'autumn',
    name: 'Autumn',
    primary: '#BF360C',
    secondary: '#D84315',
    tertiary: '#F4511E',
  },
  {
    id: 'lavender',
    name: 'Lavender',
    primary: '#7B1FA2',
    secondary: '#9C27B0',
    tertiary: '#BA68C8',
  },
];

export interface Theme {
  mode: ThemeMode;
  palette: ColorPalette;
}

export const DEFAULT_THEME: Theme = {
  mode: 'system',
  palette: COLOR_PALETTES[0],
};
